import React from 'react'
import LeftBar from '../../Components/LeftBar'
import Dashnav from '../../Components/Dashnav'
import OtherIncomeComp from './OtherIncomeComp'

function OtherIncome() {
  return (
    <div className='mainContainer'>
        <LeftBar/>
        <div className='theMainContainer'>
            <Dashnav/>
            <OtherIncomeComp/>      
        </div>
    </div>
  )
}
 
export default OtherIncome